import React from "react";
import styles from "../SpecialityFeatures/specialityFeatures.module.css";
import Animations from "../Animations/animations";
const SpecialityFeatures = ({ features }) => {
  return (
    <section className={styles.specialityFeatures}>
      <div className={styles.container}>
      <Animations animationType="fadeInUp" threshold={0.2}>
        <h2>Key Features</h2>
        </Animations>
        <Animations animationType="fadeInUp" threshold={0.2}>
        <div className={styles.specialityFeaturesWrapper}>
          {features.map((feature, index) => (
           
            <div key={index} className={styles.SpecialityFeatureBox}>
           
               
                  <img
                    src="assets/checkmark.webp"
                    width="16"
                    height="16"
                    alt="checkmark"
                    loading="lazy"
                  />
               
                <div>
                    <p>{feature}</p>
                 </div>   
          
            </div>
          
          ))}
        </div>
        </Animations>
      </div>
    </section>
  );
};

export default SpecialityFeatures;
